import { z } from "zod";

const episodeSeatResultSchema = z.object({
  win: z.array(z.boolean()).optional(),
  names: z.array(z.string()).optional(),
  scores: z.array(z.number()).optional(),
  winner: z.number().optional(),
  turns: z.number().optional(),
});

export type EpisodeSeatResult = Readonly<
  z.infer<typeof episodeSeatResultSchema>
>;

export function parseEpisodeSeatResult(
  value: unknown,
): EpisodeSeatResult | null {
  return episodeSeatResultSchema.nullable().parse(value);
}

export function wonFlagsOf({
  results,
  seatCount,
}: {
  readonly results: EpisodeSeatResult;
  readonly seatCount: number;
}): readonly (boolean | null)[] {
  const { win, winner } = results;
  return Array.from({ length: seatCount }, (_, i) => {
    if (win) return win[i] ?? null;

    return typeof winner === "number" ? winner === i : null;
  });
}
